var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayable)?_c('div',{staticClass:"d-flex justify-space-between align-center mt-0 mx-0 px__18",staticStyle:{"height":"32px","background":"#f4f4f4"}},[_c('span',{staticClass:"font__13 color__333 text--color"},[_vm._v(" "+_vm._s(_vm.propsDataSafe.title)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }